import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container py-5" }

import { useGlobalStore, useConfigStore } from '@/stores';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OurGoals',
  setup(__props) {

const globalStore = useGlobalStore();
const configStore = useConfigStore();

onMounted(() => {
  globalStore.fetchGoals(undefined);
});

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('OUR_GOALS')), 1),
    _createVNode(_component_v_list, {
      lines: "one",
      style: {"background-color":"#ffffff00"}
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(globalStore).goals, (goal, index) => {
          return (_openBlock(), _createBlock(_component_v_list_item, {
            key: index,
            title: _unref(configStore).stringLang(goal.arabic, goal.english),
            "prepend-icon": "mdi-check-bold"
          }, null, 8, ["title"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})